'use client';

import type { Editor } from '@tiptap/react';
import { useState } from 'react';

import { Emoji } from '@zoomit/icons';
import { EmojiPicker, IconButton, Popover } from '@zoomit/primitives';

type Props = {
  editor: Editor;
};

export const FeedbackEmojiPlugin = (props: Props) => {
  const { editor } = props;
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);

  const onAddEmoji = (emoji: string) => {
    editor.chain().focus().insertContent(emoji).run();
  };

  return (
    <IconButton onClick={() => setIsEmojiPickerOpen(true)} style={{ position: 'relative' }}>
      <Emoji size="dl" />
      <Popover
        triggerOffset={25}
        isOpen={isEmojiPickerOpen}
        setOpen={(value) => setIsEmojiPickerOpen(value)}
        placement="bottom-end"
        possiblePlacements={['bottom-end', 'top-end']}
        content={<EmojiPicker onSelect={({ emoji }) => onAddEmoji(emoji)} />}
        changingIsOpenWhileClicking={false}
      />
    </IconButton>
  );
};
